/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel
     */
    value?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

